import React, { useEffect } from 'react';
import { ModalBody } from 'reactstrap';
import Rodal from '../../../components/Rodal/Rodal';
import './LoiPrepComplete.scss';

const LoiPrepComplete = () => {
    useEffect(() => {
        // The tab was opened by the app via window.open, so it is allowed to close itself.
        window.close();
    }, []);

    return (
        <Rodal
            visible={true}
            showMask={false}
            width="400"
            showCloseButton={false}
            className="loi-prep-complete">
            <ModalBody>
                <h3 className="text-center">LOI Preparation Complete</h3>
                <span className="text-center d-block">
                    The document has been prepared for signing. This tab should
                    close automatically — if it doesn't, you can close it now
                    and return to the dashboard.
                </span>
            </ModalBody>
        </Rodal>
    );
};

export default LoiPrepComplete;
